import { takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getReferredBusinesses } from '../api';

export default function* saga() {
  yield takeLatest(types.GET_BUSINESSES_LIST, getPaginatedListSaga(actions, getReferredBusinesses));
}
